import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("cart");
    if (stored) setCart(JSON.parse(stored));
  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

 const addToCart = (product) => {
  setCart((prev) => {
    const existingItem = prev.find((item) => item.id === product.id);

    if (existingItem) {
      return prev.map((item) =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
    }

    return [
      ...prev,
      {
        ...product,
        UITitle: product.UITitle,
        codeName: product.codeName || product.id,
        customization: {},
        quantity: 1,
      },
    ];
  });

  setDrawerOpen(true);
};

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const removeSingleUnit = (id) => {
  setCart((prev) =>
    prev
      .map(item => {
        if (item.id === id) {
          if (item.quantity > 1) {
            return { ...item, quantity: item.quantity - 1 };
          } else {
            return null; // mark for removal
          }
        }
        return item;
      })
      .filter(Boolean)
  );
};


 function updateCustomization(itemId, index, updatedData) {
  setCart(prevCart =>
    prevCart.map(item => {
      if (item.id !== itemId) return item;

      const customization = { ...(item.customization || {}) };
      customization[index] = {
        ...(customization[index] || {}),
        ...updatedData,
      };

      return {
        ...item,
        customization,
      };
    })
  );
}

  const updateQuantity = (id, quantity) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
    setDrawerOpen(false);
    localStorage.removeItem("cart");
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        removeSingleUnit,
        updateCustomization,
        updateQuantity,
        isDrawerOpen,
        setDrawerOpen,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}